module.exports = __webpack_public_path__ + "img/header-engagementRingsLabGrownDiamonds@2x.855e152.webp";